import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getReleaseVersion = createSelector(
  (state: RootState) => state.app,
  app => app.releaseVersion,
)
